import { Value } from 'theme/style'

export default {
  paper: {
    borderRadius: Value.BorderRadius + '! important',
  },
};
